import { css } from '@emotion/css';
import * as Sentry from '@sentry/react';
import {
  Button,
  Container,
  Content,
  TextButton,
  uiConfig,
} from '@volumental/common';
import { type JSX, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from '../../components/accessible-components';

const middlePageError = css`
  text-align: center;
  position: relative;
  top: 30%;
`;
const title = css`
  font-family: ${uiConfig.styles.fontFamily};
  font-weight: ${uiConfig.styles.fontWeights.regular};
  font-size: 21px;
  line-height: 25px;
`;
const footerContentStyles = css`
  display: flex;
  flex: auto;
  flex-direction: column;
  justify-content: flex-end;
  margin-top: 10px;
  margin-bottom: 16px;
  margin-left: 24px;
  margin-right: 24px;
`;

interface GeneralErrorPageProps {
  onClose: () => void;
  onRestart?: () => void;
  errorText: string;
}

export function GeneralErrorPage({
  errorText,
  onClose,
  onRestart,
}: GeneralErrorPageProps): JSX.Element {
  const { t } = useTranslation();
  useEffect(() => {
    Sentry.captureMessage(
      `General error page: ${errorText ?? 'Unknown error'}`,
      { level: 'error' },
    );
  }, [errorText]);
  return (
    <Container>
      <Header close={onClose} />
      <Content>
        <div className={middlePageError}>
          <div className={title}>{t('SometingWentWrong')}</div>
          <TextButton onClick={onRestart} hidden={!onRestart}>
            {t('button.reload')}
          </TextButton>
        </div>
      </Content>
      <div className={footerContentStyles}>
        <Button loading={false} type="submit" onClick={onClose}>
          {t('button.done')}
        </Button>
      </div>
    </Container>
  );
}
